import type { MovementKpi } from "../utils/inventoryMovementHelpers"
import { formatNumberId } from "../utils/inventoryMovementHelpers"

type KpiStripProps = {
  kpi: MovementKpi
}

export function KpiStrip({ kpi }: KpiStripProps) {
  const items: { label: string; value: string }[] = [
    { label: "Opening Balance", value: formatNumberId(kpi.openingBalance) },
    { label: "Total In", value: formatNumberId(kpi.totalIn) },
    { label: "Total Out", value: formatNumberId(kpi.totalOut) },
    { label: "Closing Balance", value: formatNumberId(kpi.closingBalance) },
    { label: "OK Records", value: String(kpi.okCount) },
    { label: "Warning", value: String(kpi.warningCount) },
    { label: "Error", value: String(kpi.errorCount) },
    { label: "Control Score", value: `${kpi.controlScorePct}%` }
  ]

  return (
    <div className="grid grid-cols-2 gap-2 sm:gap-3 md:grid-cols-4 xl:grid-cols-8">
      {items.map((item) => (
        <div
          key={item.label}
          className="card card-compact flex min-h-[5.5rem] flex-col items-center justify-center border border-[#dadada] bg-base-100 px-2 py-3 text-center shadow-sm sm:min-h-[6rem] sm:px-3">
          <p className="text-[10px] font-bold uppercase leading-tight text-base-content/55 sm:text-[11px]">
            {item.label}
          </p>
          <p className="mt-1 break-all text-xl font-bold leading-tight text-base-content sm:text-2xl xl:text-3xl">
            {item.value}
          </p>
        </div>
      ))}
    </div>
  )
}
